import { Compiler } from '@/dsl/compilers';
import { formatDevices } from '@/renders/format';
import type { UnifiedContext } from '../context';

export const handleDevices = (el: HTMLElement, ctx: UnifiedContext) => {
  const { storeDevices, storeTextSingle, storeTextMany } = el.dataset;
  if (storeDevices === undefined) return;
  const option = ctx.option;
  if (!option) return;

  // input
  if (el instanceof HTMLInputElement) {
    el.value = String(option.getDevices());
    return;
  }

  // select
  if (el instanceof HTMLSelectElement) {
    const selectedDevices = option.getDevices();
    const available = Compiler.array(storeDevices) ?? option.getProduct().getDevices().values;

    el.options.length = 0;
    for (const device of available) {
      const isSelected = device === selectedDevices;
      const text = formatDevices(
        device,
        storeTextSingle,
        storeTextMany
      );
      const htmlOption = new Option(
        text,
        String(device),
        isSelected,
        isSelected
      );
      htmlOption.setAttribute('data-store-set-devices', String(device));
      el.add(htmlOption);
    }
    return;
  }

  // generic content
  el.textContent = String(option.getDevices());
};
